import * as React from "react";
const SvgFiRrItAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-it-alt_svg__a)">
      <path
        fill="#062147"
        d="M18 15.991a5.98 5.98 0 0 1-2.788 5.068.47.47 0 0 0-.212.4v1.54a1 1 0 1 1-2 0v-1.54c0-.855.426-1.637 1.141-2.09A3.98 3.98 0 0 0 16 15.99c0-.98-.359-1.915-1-2.641v.375c0 1.657-1.028 2.983-2.501 3.225a3.03 3.03 0 0 1-2.439-.672A3 3 0 0 1 9 13.99v-.641c-.641.725-1 1.66-1 2.641 0 1.377.695 2.641 1.86 3.379a2.46 2.46 0 0 1 1.14 2.09v1.54a1 1 0 1 1-2 0v-1.54a.47.47 0 0 0-.212-.4A5.98 5.98 0 0 1 6 15.991a5.98 5.98 0 0 1 2.133-4.582 1.72 1.72 0 0 1 1.855-.244A1.73 1.73 0 0 1 11 12.748v1.243a1.003 1.003 0 0 0 1.174.986c.486-.08.825-.594.825-1.251v-.979a1.73 1.73 0 0 1 1.012-1.583 1.73 1.73 0 0 1 1.854.245 5.98 5.98 0 0 1 2.134 4.583zM4.5 3a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 4.5 3m4 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 3M24 5v12c0 2.757-2.243 5-5 5a1 1 0 1 1 0-2c1.654 0 3-1.346 3-3V9H2v8c0 1.654 1.346 3 3 3a1 1 0 1 1 0 2c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-2 2V5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-it-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrItAlt;
